import {
  createDataStore,
  createDataHooks,
} from '@/shared/stores/create-data-store'
import {
  ProductServiceColorGqlOutput,
  useProductServiceAllColorsLazyQuery,
} from 'zma-react-sdk/product-service'
import { useTenantStore } from '@/stores/tenantStore'

const colorStore = createDataStore<Array<ProductServiceColorGqlOutput>>({
  dataTransformer: (data) => data?.productServiceAllColors?.data || [],
})

const { useData, useClearData, useUpdateData } = createDataHooks(
  () => colorStore(),
  () => {
    const { selectedTenantId } = useTenantStore()
    const [queryFn, queryState] = useProductServiceAllColorsLazyQuery({
      context: {
        headers: {
          'x-tenant-id': selectedTenantId,
        },
      },
    })
    const wrappedQuery = () =>
      queryFn({
        variables: {
          pagination: {
            skip: 0,
            limit: 1000,
          },
        },
      })
    return [wrappedQuery, queryState] as [
      typeof wrappedQuery,
      typeof queryState,
    ]
  }
)

export function useColorData() {
  const { data, loading, error } = useData()
  return {
    data: data ?? [],
    loading,
    error,
  }
}

export const useClearColorData = useClearData

export const useUpdateColorData = useUpdateData
